import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js"; // Function to fetch user data
import {
  getOrgById,
  getOrgByRef,
  transformAppLogsToTable,
  transformLogsToTable,
} from "../../models/OrgFunctions.js"; // Functions to fetch org and client data
import Divider from "../../layout/Divider.js";
import Space from "../../layout/Space.js";
import DataGridFull from "../../tables/DataGridFull.js";
import { Switch, useTheme } from "@mui/material";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import Icon1 from "../../icons/Icon.js";
import {
  getDocDataByRef,
  getLocalStringFromFlutter,
  queryCollection,
} from "../../models/DataFunctions.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import TextField2 from "../../textfields/TextField2.js";
import deleteDocApi from "../../api/database/deleteDocApi.js";
import { useAppContext } from "../../config/AppContext.js";
import Modal1 from "../../modals/Modal1.js";
import sendPushNotification from "../../api/send/sendPushNotification.js";
import { message } from "antd";
import { Token } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import { set } from "date-fns";
import DataGridGPT2 from "../../tables/DataGridGPT2.js";
function AppLogs({ navigateWorkspace }) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [pushOpen, setPushOpen] = useState(false);
  const [title = "", setTitle] = useState("");
  const [body = "", setBody] = useState("");

  const [selected_log, setSelectedLog] = useState(null);
  const [count, setCount] = useState(1000);
  const [logs, setLogs] = useState([]);
  // Function to navigate to a client by ID
  const gotoUser = async (log) => {
    const obj = await getDocDataByRef(log.ref);
    setSelectedLog(obj);
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleSendPush = async () => {
    let user_filters = [
      {
        field: "email",
        operator: "==",
        value: selected_log.email,
      },
    ];
    const users = await queryCollection("user", user_filters);
    if (users.length > 0) {
      const token = await getOrRefreshFirebaseToken();
      await sendPushNotification(title, body, users[0].id, token, prefix);
      handleClickVariant("Push Notification Sent", "success");
    } else {
      handleClickVariant("User not found", "error");
    }
    setPushOpen(false);
  };
  const handleDeleteLog = async (log) => {
    await deleteDocApi(log.ref, prefix);
    handleFetchData();
  };
  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgById(user.org_id);
      let logs = [];
      let filters = [];

      filters = [];
      // Fetch clients associated with the user's organization
      logs = await queryCollection("applog", filters, 500, "date", "desc");

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformAppLogsToTable(logs, theme, "");

      // Update state if the user data is new or changed

      setUserData(user);
      setOrgData(org);
      setLogs(logs);
      setRows(rows);
      setColumns(columns);

      // Set options for the search bar (client names)
      setOptions(logs.map((log) => log.url));
    }
  };

  function highlightErrors(big_text) {
    if (!big_text) {
      return <span></span>;
    }

    // search for "File not found" and highlight it in red
    const fileRegex = /File not found/g;
    const errorRegex = /Error/g;

    const successUpdated = /Successfully |database:/g;
    // Replace the URL with the highlighted version

    const highlightedText = big_text.replace(successUpdated, (url) => {
      return `<span class="text-green-500">${url}</span>`;
    });

    const highlightedText2 = highlightedText.replace(fileRegex, (url) => {
      return `<span class="text-red-500">${url}</span>`;
    });

    const highlightedText3 = highlightedText2.replace(errorRegex, (url) => {
      return `<span class="text-red-500">${url}</span>`;
    });

    // Render the result as HTML within a span
    return <span dangerouslySetInnerHTML={{ __html: highlightedText3 }} />;
  }

  const handleSearchChange = (valuee) => {
    let value = searchValue;
    if (valuee) {
      value = valuee;
    } else {
      value = "";
    }

    const { rows, columns } = transformAppLogsToTable(logs, theme, value);

    setRows(rows);
    setColumns(columns);
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  // Render the client data
  return (
    <div className="flex flex-col h-screen w-full p-4">
      <Modal1 isOpen={pushOpen} onClose={() => setPushOpen(false)}>
        <div className="flex flex-col gap-4 bg-white p-4 rounded-xl">
          <TextField2
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField2
            value={body}
            onChange={(e) => setBody(e.target.value)}
            label="Body"
          />
          <PrimaryButton onClick={handleSendPush}>Send</PrimaryButton>
        </div>
      </Modal1>
      <div className=" flex flex-row w-full h-full">
        <div className="flex flex-col h-full w-full" y={10}>
          <div className="text-hx font-medium flex flex-row gap-4">
            <div>Logs </div>
            <TextField2
              className="max-w-c100"
              label="Nombre de logs"
              value={count}
              onChange={(e) => setCount(e.target.value)}
            />
            <SecondaryButton
              onClick={() => {
                handleFetchData();
              }}
            >
              Apply
            </SecondaryButton>
          </div>
          <Space y={10} />
          <div className="flex flex-row w-full items-center">
            {/* Search Bar */}
            <div className="flex flex-row w-c700  gap-2 items-center">
              <TextField2
                label="Chercher"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <PrimaryButton
                disabled={searchValue == ""}
                className="h-fit "
                onClick={() => handleSearchChange(searchValue)}
              >
                Filtrer
              </PrimaryButton>
              <PrimaryButton
                className="h-fit "
                onClick={() => {
                  setSearchValue("");
                  handleSearchChange(null);
                }}
              >
                Reset
              </PrimaryButton>
            </div>
          </div>

          {/* DataGrid displaying the clients */}
          <div className="w-full h-full pb-8 overflow-auto mb-4 mt-3">
            <div className="h-full  min-h-6 max-w-c600">
              <DataGridGPT2
                rows={rows}
                columns={columns}
                onClick={gotoUser}
                initial_sort_field="date"
                initial_asc="desc"
              />
            </div>
          </div>
        </div>

        <Divider orientation="vertical" />
        <div className="flex-grow w-full  h-full p-2 pb-10  mb-8 text-black ">
          {selected_log && (
            <div className="flex  bg-white rounded-xl flex-col  h-full p-2 gap-1 text-h4 overflow-auto">
              <div className="flex flex-col gap-1 text-neutral-400">
                <div> {selected_log.id}</div>
                <div> {getLocalStringFromFlutter(selected_log.date)}</div>
                <div> {selected_log.email}</div>
              </div>
              <SecondaryButton
                className="h-fit w-fit"
                onClick={() => handleDeleteLog(selected_log)}
              >
                Supprimer
              </SecondaryButton>
              <SecondaryButton
                className="h-fit w-fit"
                onClick={() => setPushOpen(true)}
              >
                Send Push Notification
              </SecondaryButton>
              <div style={{ whiteSpace: "pre-line" }}>
                {highlightErrors(selected_log.logs)}
              </div>
              <Space y={10} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppLogs;
